import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-picture-copy",
  "use": "icon-si-glyph-picture-copy-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-picture-copy\" id=\"icon-si-glyph-picture-copy\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>89</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g fill=\"#434343\">\n            <path d=\"M14.969,0.031 L5,0.031 L5,2.969 L6,2.969 L6,1 L14.027,1 L14.027,8.001 L11,8.001 L11,10.952 L14.969,10.952 L14.969,0.031 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M0,4 L0,15 L10,15 L10,4 L0,4 L0,4 Z M8.967,12 L0.967,12 L0.967,5 L8.967,5 L8.967,12 L8.967,12 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-picture-copy.svg
// module id = XZ2g
// module chunks = 62